import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-details.vue?vue&type=template&id=4d9244d3"
import script from "./reisetermin-card-vorgaenge-details.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports